<template>
  <div>
    <van-skeleton title  :row="0" :loading="loading">
    <div class="driver-list" v-if="userList.length>0">
      <div v-for="item in userList" :key="item.id">
        <div class="driver-item" >
          <div class="driver-item-content">
            <span class="driver-name">姓名:{{item.name}}</span>
            <div class="bpm-status" v-if="item.bpmStatus == 1">
              <van-tag type="danger">未提交</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.bpmStatus == 2">
              <van-tag type="warning">待审核</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.bpmStatus == 3">
              <van-tag type="primary">审核成功</van-tag>
            </div>
            <div class="content-item first-item">联系电话:{{item.telphone}}</div>
            <div class="content-item">身份证:{{item.shenfenzheng}}</div>
            <div class="content-item">驾驶证截至日期:{{item.jiashizhengyxq}}</div>
            <div class="content-item">从业资格证截至日期:{{item.congyezigeyxq}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <van-empty description="您尚未添加司机信息，请先去添加司机信息">
        <van-button round type="danger" class="bottom-button" @click="addDriverInfo">添加司机信息</van-button>
      </van-empty>
    </div>
    </van-skeleton>
  </div>
</template>
<script>
import api from "@/fetch/api";
import { Toast } from 'vant';
export default {
  data(){
    return {
      openid:"",
      userList:[],
      loading:true,
    };
  },
  methods:{
    getDriverByOpenid() {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      api.getDriverByOpenid(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.userList = resData.data;
          that.loading = false;
          if(that.userList.length>0 && that.userList[0].bpmStatus == '3')
          {
            that.$emit("update-props",true);
            that.$emit("update-info",'driver',that.userList[0]);
          }
          else{
            that.$emit("update-props",false);
          }
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');

      });
    },
    addDriverInfo()
    {
      this.$router.push({
        name: 'driverList',
      })
    },
  },
  created(){
    this.getDriverByOpenid();
  },

}

</script>
<style lang="scss" scoped>
.driver-list {
    margin-bottom: 4.75rem;
    margin-top: 1rem;
    .driver-item {
        margin: 0 1rem 1rem;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .driver-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .driver-name {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }

            .first-item {
                margin-top: 0.625rem;
            }
        }
        .driver-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
        .btns-box{
          .btn-op{
            width: 33.3%;
          }
          .btn-op2
          {
            width: 50%;
          }
        }
    }
}

</style>
